import { Injectable } from '@angular/core';
import { convict } from '../../config/convict';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config = convict;

  public getConfig() {
    return this.config;
  }
}
